module.exports = __webpack_public_path__ + "static/media/006-monkey.56ab419c.svg";